/*
 * @Description: 
 * @Autor: Ray7hw
 * @LastEditTime: 2020-10-21 10:12:30
 */
import Vue from 'vue'
import Router from 'vue-router'
import login from './pages/login'
import singup from './pages/singup'


Vue.use(Router)


let router = new Router({
  routes: [
    {
      path: '/',
     //component: layout
      redirect: '/layout'
     },
   // {
    //  path: '/',
     // redirect: '/yzindex'
    //},
    {
      path: '/login',
      component: login
    },
    {
      path: '/singup',
      component: singup,

    },
    {
      path: '/Protocol',

      component: () => import('@/pages/Protocol')
    },
    {
      path: '/forgetpaw',
      component: () => import('@/pages/forgetpaw')
    },


    {
      path: '/layout',
      component: () => import('@/pages/layout'),
      children: [{
          path: 'goindex',
          component: () =>
            import('@/pages/goindex'),
          name: 'goindex',
          meta: {
            title: '文交所官网',
            icon: 'maintain',
          }
        },,{
          path: 'gokbm',
          component: () =>
            import('@/pages/gokbm'),
          name: 'gokbm',
          meta: {
            title: '可线上报名的项目',
            icon: 'maintain',
          }
        }, , {
          path: 'index',
          component: () =>
            import('@/pages/index'),
          name: 'index',
          meta: {
            title: '个人信息',
            icon: 'maintain',
          }
        },
        {
          path: 'projectRegistration',
          component: () =>
            import('@/pages/projectRegistration'),
          name: 'projectRegistration',
          meta: {
            title: '项目报名',
            icon: 'maintain',
          }
        },
        {
          path: 'ModifyRegistration',
          component: () =>
            import('@/pages/ModifyRegistration'),
          name: 'ModifyRegistration',
        },

        {
          path: 'onlineRegistration',
          component: () =>
            import('@/pages/onlineRegistration'),
          name: 'onlineRegistration',
        },
        {
          path: 'participateProjects',
          component: () =>
            import('@/pages/participateProjects'),
          name: 'participateProjects',
          meta: {
            title: '我参与的项目',
            icon: 'maintain',
          }
        },
        {
          path: 'isParticipating',
          component: () =>
            import('@/pages/isParticipating'),
          name: 'isParticipating',
          meta: {
            title: '我正在参与的项目',
            icon: 'maintain',
          }
        },

        {
          path: 'capitalFlow',
          component: () =>
            import('@/pages/capitalFlow'),
          name: 'capitalFlow',
          meta: {
            title: '我的保证金流水',
            icon: 'maintain',
          }
        },
        {
          path: 'modifymima',
          component: () =>
            import('@/pages/modifymima'),
          name: 'modifymima',
          meta: {
            title: '修改密码',
            icon: 'maintain',
          }
        },


        {
          path: 'erweima',
          component: () =>
            import('@/pages/erweima'),
          name: 'erweima',
        },
        {
          path: 'modifyInformation',
          component: () =>
            import('@/pages/modifyInformation'),
          name: 'modifyInformation',
          meta: {
            title: '修改用户信息',
            icon: 'maintain',
          }
        },

        {
          path: 'modifyphone',
          component: () =>
            import('@/pages/modifyphone'),
          name: 'modifyphone',
          meta: {
            title: '修改手机号',
            icon: 'maintain',
          }
        },


      ]
    },



  ]
})



const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router



// WEBPACK FOOTER //
// ./src/router.js